/**
 * Created by jv on 16/01/2017.
 */
const utils = require("Sources/utils/utils");
const request = require("Sources/services/request");
const Subscription = require("Sources/models/subscription");
const Product = require("Sources/models/product");
const DigitalPurchase = require("Sources/models/digital-purchase");
const SubscriptionModule = require("Sources/models/subscription-module");
const SubscriptionGuest = require("Sources/models/subscription-guest");
const SubscriptionUser = require("Sources/models/subscription-user");
const Ticket = require("Sources/models/ticket");
const SubscriptionBorrow = require("Sources/models/subscription-borrow");
const Error = require("Sources/models/error");

var subscriptionServices = {};

(function(SubscriptionServices)
{
  function dataToError(data, callback)
  {
    if(utils.isFunction(callback))
    {
      if(data.hasOwnProperty("exception"))
      {
        callback(new Error(data.exception));
      }
      else
      {
        callback(new Error({
          code: null,
          message: null
        }));
      }
    }
  }

  SubscriptionServices.getSubscriptionsForProfile = function(profileKey, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("get_subscriptions_for_user"),
      cache: false,
      dataType: "json",
      data: {
        "profile-key": profileKey
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        var subscriptions = [];

        if(data.result.result.hasOwnProperty("summaries"))
        {
          for(var i = 0; i < data.result.result.summaries.length; i++)
          {
            subscriptions.push(new Subscription(data.result.result.summaries[i]));
          }
        }

        successCb(subscriptions);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  SubscriptionServices.getLinkedSubscriptionsForProfile = function(profileKey, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("get_linked_subscriptions_for_user"),
      cache: false,
      dataType: "json",
      data: {
        "profile-key": profileKey
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        var subscriptions = [];

        if(data.result.result.hasOwnProperty("summaries"))
        {
          for(var i = 0; i < data.result.result.summaries.length; i++)
          {
            subscriptions.push(new Subscription(data.result.result.summaries[i]));
          }
        }

        successCb(subscriptions);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  SubscriptionServices.getDigitalPurchasesForProfile = function(profileKey, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("list_digital_purchases"),
      cache: false,
      dataType: "json",
      data: {
        "profile-key": profileKey
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        var digitalPurchases = [];

        if(data.result.result.hasOwnProperty("digital-purchase-list"))
        {
           for(var i = 0; i < data.result.result["digital-purchase-list"].length; i++)
           {
             digitalPurchases.push(new DigitalPurchase(data.result.result["digital-purchase-list"][i]));
           }
        }

        successCb(digitalPurchases);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  SubscriptionServices.getSubscriptionDetails = function(key, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("get_subscription_details"),
      cache: false,
      dataType: "json",
      data: {
        "subscription-key": key
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(new Subscription(data.result.result));
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  SubscriptionServices.getOrdersForSubscription = function(key, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("list_orders_for_subscription"),
      cache: false,
      dataType: "json",
      data: {
        "subscription-key": key
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(data.result.result.orders);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  SubscriptionServices.getActivationsForToken = function(tokenKey, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("get_activations_for_token"),
      cache: false,
      dataType: "json",
      data: {
        "token-key": tokenKey
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(data.result.result.activations);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  SubscriptionServices.updateToken = function(tokenKey, extraInstallations, extraUsers, successCb, failCb)
  {
    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
      url:  utils.getServiceUrl("update_token"),
      cache: false,
      dataType: "json",
      data: {
        "token-key": tokenKey,
        "extra-installations": extraInstallations,
        "extra-users": extraUsers
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb();
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  SubscriptionServices.deleteActivation = function(installationId, userKey, tokenKey, successCb, failCb)
  {
    request.post({ // Should actually be DELETE but java can't handle parameter key-value pairs for PUT/DELETE by default
      url:  utils.getServiceUrl("delete_activation") + "?key=" + tokenKey,
      cache: false,
      dataType: "json",
      data: {
        "installation-id": installationId,
        "user-key": userKey,
        "token-key": tokenKey
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb();
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  SubscriptionServices.updateContact = function(contactObj, successCb, failCb)
  {
    request.post({  // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
      url:  utils.getServiceUrl("update_subscription_contact"),
      cache: false,
      dataType: "json",
      data: contactObj
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(new Subscription(data.result.result));

        // if(utils.isArray(data.result.result.contacts) && data.result.result.contacts.length === 1)
        // {
        //   successCb(data.result.result.contacts[0]);
        // }
        // else
        // {
        //   utils.devLog("JSON result is not consistent - expected data.result.result.contacts with 1 contact");
        //   successCb(data.result.result);
        // }
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  SubscriptionServices.addInvolvedPerson = function(subscriptionKey, email, successCb, failCb)
  {
    request.post({  // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
      url:  utils.getServiceUrl("add_subscription_involved_person"),
      cache: false,
      dataType: "json",
      data: {
        "subscription-key": subscriptionKey,
        "email": email
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        // successCb(new User(data.result.result));
        successCb(new Subscription(data.result.result));
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  SubscriptionServices.removeInvolvedPerson = function(subscriptionKey, profileKey, successCb, failCb)
  {
    request.post({  // Should actually be DELETE but java can't handle parameter key-value pairs for PUT/DELETE by default
      url:  utils.getServiceUrl("remove_subscription_involved_person"),
      cache: false,
      dataType: "json",
      data: {
        "subscription-key": subscriptionKey,
        "profile-key": profileKey
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        // successCb(data);
        successCb(new Subscription(data.result.result));
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  SubscriptionServices.renewSubscription = function(subscriptionKey, purchaseOrderNumber, successCb, failCb)
  {
    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
      url:  utils.getServiceUrl("extend_subscription"),
      cache: false,
      dataType: "json",
      data: {
        "subscription-key": subscriptionKey,
        "bestelbon-number": purchaseOrderNumber
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(data);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  SubscriptionServices.cancelSubscription = function(subscriptionKey, successCb, failCb)
  {
    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
      url:  utils.getServiceUrl("cancel_subscription"),
      cache: false,
      dataType: "json",
      data: {
        "subscription-key": subscriptionKey
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(data);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  SubscriptionServices.updateSubscription = function(data, successCb, failCb)
  {
    request.post({ // Should actually be PUT but java can't handle parameter key-value pairs for PUT/DELETE by default
      url:  utils.getServiceUrl("update_subscription"),
      cache: false,
      dataType: "json",
      data: {
        "subscription-key": data.subscriptionKey,
        "prolong": data.prolong,
        "bestelbon-required": data.purchaseOrderRequired,
        "vat": data.vatNumber,
        "company-number": data.companyNumber
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(data);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  SubscriptionServices.sendSubscriptionOffer = function(subscriptionKey, successCb, failCb)
  {
    request.post({
      url:  utils.getServiceUrl("get_subscription_offer"),
      cache: false,
      dataType: "json",
      data: {
        "subscription-key": subscriptionKey
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb(data);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  SubscriptionServices.getSubscriptionModules = function(subscriptionKey, successCb, failCb)
  {
    request.get({
        url:  utils.getServiceUrl("get_subscription_modules"),
        cache: false,
        dataType: "json",
        data: {
          "subscription-key": subscriptionKey
        }
      },
      function(data)
      {
        if(utils.isFunction(successCb))
        {
          var modules = [];

          if(data.result.result.hasOwnProperty("subscription-module-list"))
          {
            for(var i = 0; i < data.result.result["subscription-module-list"].length; i++)
            {
              modules.push(new SubscriptionModule(data.result.result["subscription-module-list"][i]));
            }
          }

          successCb(modules);
        }
      },
      function(data)
      {
        dataToError(data, failCb);
      });
  };

  SubscriptionServices.getSubscriptionGuests = function(subscriptionKey, successCb, failCb)
  {
    request.get({
        url:  utils.getServiceUrl("get_subscription_guests"),
        cache: false,
        dataType: "json",
        data: {
          "subscription-key": subscriptionKey
        }
      },
      function(data)
      {
        if(utils.isFunction(successCb))
        {
          var guests = [];

          if(data.result.result.hasOwnProperty("subscription-guest-list"))
          {
            for(var i = 0; i < data.result.result["subscription-guest-list"].length; i++)
            {
              guests.push(new SubscriptionGuest(data.result.result["subscription-guest-list"][i]));
            }
          }

          successCb(guests);
        }
      },
      function(data)
      {
        dataToError(data, failCb);
      });
  };

//  SubscriptionServices.inviteHighschoolStudent = function(subscriptionKey, email, successCb, failCb)
//  {
//    request.get({
//        url:  utils.getServiceUrl("invite_highschool_student"),
//        cache: false,
//        dataType: "json",
//        data: {
//          "subscription-key": subscriptionKey,
//          "email" : email
//        }
//      },
//      function(data)
//      {
//        if(utils.isFunction(successCb))
//        {
//          successCb();
//        }
//      },
//      function(data)
//      {
//        dataToError(data, failCb);
//      });
//  };

  SubscriptionServices.addSubscriptionGuest = function(subscriptionKey, emailList, successCb, failCb)
  {
    request.get({
        url:  utils.getServiceUrl("add_subscription_guest"),
        cache: false,
        dataType: "json",
        data: {
          "subscription-key": subscriptionKey,
          "email-list" : emailList
        }
      },
      function(data)
      {
        if(utils.isFunction(successCb))
        {
          successCb();
        }
      },
      function(data)
      {
        dataToError(data, failCb);
      });
  };

  SubscriptionServices.deleteSubscriptionGuest = function(subscriptionKey, subscriptionGuestKey, successCb, failCb)
  {
    request.get({
        url:  utils.getServiceUrl("delete_subscription_guest"),
        cache: false,
        dataType: "json",
        data: {
          "subscription-key": subscriptionKey,
          "subscription-guest-key" : subscriptionGuestKey
        }
      },
      function(data)
      {
        if(utils.isFunction(successCb))
        {
          successCb();
        }
      },
      function(data)
      {
        dataToError(data, failCb);
      });
  };

  SubscriptionServices.addSubscriptionUser = function(subscriptionKey, email, successCb, failCb)
  {
    request.get({
        url:  utils.getServiceUrl("add_subscription_user"),
        cache: false,
        dataType: "json",
        data: {
          "subscription-key": subscriptionKey,
          "email" : email
        }
      },
      function(data)
      {
        if(utils.isFunction(successCb))
        {
          successCb();
        }
      },
      function(data)
      {
        dataToError(data, failCb);
      });
  };

  SubscriptionServices.deleteSubscriptionUser = function(subscriptionKey, profileKey, successCb, failCb)
  {
    request.get({
        url:  utils.getServiceUrl("delete_subscription_user"),
        cache: false,
        dataType: "json",
        data: {
          "subscription-key": subscriptionKey,
          "profile-key" : profileKey
        }
      },
      function(data)
      {
        if(utils.isFunction(successCb))
        {
          successCb();
        }
      },
      function(data)
      {
        dataToError(data, failCb);
      });
  };

  SubscriptionServices.getSubscriptionUsers = function(subscriptionKey, successCb, failCb)
  {
    request.get({
        url:  utils.getServiceUrl("get_subscription_users"),
        cache: false,
        dataType: "json",
        data: {
          "subscription-key": subscriptionKey
        }
      },
      function(data)
      {
        if(utils.isFunction(successCb))
        {
          var users = [];

          if(data.result.result.hasOwnProperty("subscription-user-list"))
          {
            for(var i = 0; i < data.result.result["subscription-user-list"].length; i++)
            {
              users.push(new SubscriptionUser(data.result.result["subscription-user-list"][i]));
            }
          }

          successCb(users);
        }
      },
      function(data)
      {
        dataToError(data, failCb);
      });
  };

  SubscriptionServices.listProductsForSubscription = function(subscriptionKey, successCb, failCb)
  {
    request.get({
        url:  utils.getServiceUrl("get_subscription_products"),
        cache: false,
        dataType: "json",
        data: {
          "subscription-key": subscriptionKey
        }
      },
      function(data)
      {
        if(utils.isFunction(successCb))
        {
          var products = [];

          if(data.result.result.hasOwnProperty("wapiti-product-list"))
          {
            for(var i = 0; i < data.result.result["wapiti-product-list"].length; i++)
            {
              products.push(new Product(data.result.result["wapiti-product-list"][i]));
            }
          }

          successCb(products);
        }
      },
      function(data)
      {
        dataToError(data, failCb);
      });
  };

  SubscriptionServices.listSubscriptionTickets = function(subscriptionKey, ticketType, successCb, failCb)
  {
    request.get({
        url:  utils.getServiceUrl("get_subscription_tickets"),
        cache: false,
        dataType: "json",
        data: {
          "subscription-key": subscriptionKey,
          "ticket-type": ticketType
        }
      },
      function(data)
      {
        if(utils.isFunction(successCb))
        {
          var tickets = [];

          if(data.result.result.hasOwnProperty("ticket-list"))
          {
            for(var i = 0; i < data.result.result["ticket-list"].length; i++)
            {
              tickets.push(new Ticket(data.result.result["ticket-list"][i]));
            }
          }

          successCb(tickets);
        }
      },
      function(data)
      {
        dataToError(data, failCb);
      });
  };

  SubscriptionServices.addBorrowForSubscription = function(subscriptionKey, productKey, title, count, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("add_subscription_borrow"),
      cache: false,
      dataType: "json",
      data: {
        "subscription-key": subscriptionKey,
        "product-key": productKey,
        "product-name": title,
        "count": count
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        if(data.result.hasOwnProperty("url"))
        {
          successCb(data.result["url"]);
        }
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  SubscriptionServices.getSubscriptionBorrowList = function(subscriptionKey, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("get_subscription_borrows"),
      cache: false,
      dataType: "json",
      data: {
        "subscription-key": subscriptionKey
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        var subscriptionBorrowList = [];

        if(data.result.result.hasOwnProperty("subscription-borrow-list"))
        {
          for(var i = 0; i < data.result.result["subscription-borrow-list"].length; i++)
          {
            subscriptionBorrowList.push(new SubscriptionBorrow(data.result.result["subscription-borrow-list"][i]));
          }
        }

        successCb(subscriptionBorrowList);
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };

  SubscriptionServices.requestDemo = function(type, organisation, role, street, number, zip, city, successCb, failCb)
  {
    request.get({
      url:  utils.getServiceUrl("request_demo"),
      cache: false,
      dataType: "json",
      data: {
        "type": type,
        "organisation": organisation,
        "role": role,
        "street": street,
        "number": number,
        "zip": zip,
        "city": city
      }
    },
    function(data)
    {
      if(utils.isFunction(successCb))
      {
        successCb();
      }
    },
    function(data)
    {
      dataToError(data, failCb);
    });
  };


}(subscriptionServices));

module.exports = subscriptionServices;



// WEBPACK FOOTER //
// ./app/js/services/fundels/subscription-services.js